import { getLocales } from '@change-corgi/config/locales';
import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_OG_IMAGE_RENDER = defineFcm('psf_og_image_render')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean', optional: true },
				backfill_enabled: { type: 'boolean', optional: true },
				locales: { type: 'array', optional: true, shape: { type: 'enum', values: getLocales() } },
				backfill_dry_run: { type: 'boolean', optional: true },
				backfill_rate: { type: 'number', optional: true },
				backfill_nightly_limit: { type: 'number', optional: true },
				backfill_run_id: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault({ enabled: false, backfill_enabled: false, locales: [] })
	.toConfig({
		owner: 'squad-platypus',
		scope: 'monorail',
		supportedGroups: { global: true },
		context: 'PSF OG image renders (psf_og_image photo tag)',
		description: `Gates the renders of the PSF OG image variants (photo tag psf_og_image) in change_production.
			"enabled" turns the publish, update and backfill renders on, for petitions in "locales" only.
			"backfill_enabled" pauses only the backfill and keeps the publish and update renders on.
			The backfill runs every 30 minutes from 9:00 to 10:30 PM Pacific. The other backfill keys tune it:
			"backfill_dry_run" is on unless it is false. A dry run counts the candidates, but enqueues nothing.
			"backfill_rate" is the render jobs per minute, an integer from 1 to 60 (30 when it is not set).
			"backfill_nightly_limit" is the petitions enqueued per Pacific night. When it is not set, the backfill enqueues nothing.
			"backfill_run_id" names the progress cursor (letters, digits, _ and -, up to 40). A new value starts the list again.
			Separate from the psf_og_image link FCM, which gates the share link segment and the enrollment. See CHANGE-99397.`,
		template: {
			enabled: true,
			backfill_enabled: false,
			locales: ['en-US'],
			backfill_dry_run: true,
			backfill_rate: 30,
			backfill_nightly_limit: 0,
		},
	});
